import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S01 = () => {
  return (
    <section className={cx('container')}>
      <h1 className={cx('title')}>LEVRAI</h1>
      <p className={cx('desc')}>
        Premium Family Cosmetics from Korea,
        <br />
        made for joyful moments with your family
      </p>
    </section>
  );
};

export default S01;
